import {Component} from "@angular/core";
import {EntitlementSearchModel} from "../entitlement-search.model";
import {EntitlementEntityModel} from "../entitlement-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-entitlement-search-page",
    templateUrl: "./entitlement-search-page.component.html",
    providers: [provideSearchModel(EntitlementSearchModel), provideEntityModel(EntitlementEntityModel)]
})
export class EntitlementSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
